async function sendPrivateMessage(loggedInUserId, targetUserId, messageContent, execute) {    
    
    // Endpoint to create a one-on-one chat
    const createChatEndpoint = `https://graph.microsoft.com/v1.0/chats`;
    const chatData = {
        chatType: "oneOnOne",
        members: [
            {
                '@odata.type': '#microsoft.graph.aadUserConversationMember',
                roles: ['owner'],
                'user@odata.bind': `https://graph.microsoft.com/v1.0/users('${loggedInUserId}')`
            },
            {
                '@odata.type': '#microsoft.graph.aadUserConversationMember',
                roles: ['owner'],
                'user@odata.bind': `https://graph.microsoft.com/v1.0/users('${targetUserId}')`
            }
        ]
    };
    const createChatResponse = await execute('POST', createChatEndpoint, chatData);
    const responseJson = await createChatResponse.json();
    const chatId = responseJson.id;
    const sendMessageEndpoint = `https://graph.microsoft.com/v1.0/chats/${chatId}/messages`;
    const messageData = {
        body: {
            content: messageContent,
            contentType: 'text'
        }
    };
    const sendMessageResponse = await execute('POST', sendMessageEndpoint, messageData);
    return sendMessageResponse;
}

export default sendPrivateMessage;
